<template>
  <cgn-form-input
    type="email"
    inputmode="email"
  />
</template>

<script setup lang="ts">
</script>
